import React from 'react';
import { useConsent } from '../context/ConsentContext';
export default function PrivacyChoicesButton({ style = {} }) { const { openPreferences } = useConsent(); return <button type="button" onClick={openPreferences} style={{ border: 0, padding: 0, background: 'none', cursor: 'pointer', font: 'inherit', ...style }}>Privacy choices</button>; }
